import {
  APP_CHANGE_LANGUAGE,
  APP_GET_LOGO_REQUEST,
  APP_NAVIGATION_HIDDEN,
  APP_SET_BREAK_POINT
} from '../constants/app.constants';

export const dispatchGW1Action = (type, payload) => ({
  type,
  payload,
});

export const changeLanguage = ({ idioma }) => ({
  type: APP_CHANGE_LANGUAGE,
  payload: { idioma },
});

export const getLogo = payload => ({
  type: APP_GET_LOGO_REQUEST,
  payload,
});
export const setBreakPoint = payload => ({
  type: APP_SET_BREAK_POINT,
  payload,
});
export const setPageNavigationIsHidden = (hidden, hiddenHeight) => ({
  type: APP_NAVIGATION_HIDDEN,
  payload: { hidden, hiddenHeight },
});
